import jQuery from 'jquery'

export default function () {
  window.$ = jQuery
}
